import { type SelectOption } from '../../../../components';
import {
  DSRC_DECISION_TYPE,
  EntranceRequirement,
  OFFER_TYPE,
  TuitionAssistantship,
} from './constants';
import { PAGE_TEXT } from '../../lang';

const STEP_TEXT = PAGE_TEXT.DRC_ASSESSMENT_DETAILS.ASSESSMENT;
const ADMISSION_FORM_TEXT = STEP_TEXT.STEP_G;

export const approveOptions: SelectOption[] = [
  { label: 'approve', value: DSRC_DECISION_TYPE.OFFER_APPROVED },
  { label: 'return', value: DSRC_DECISION_TYPE.RETURN },
  { label: 'reject', value: DSRC_DECISION_TYPE.REJECT },
];
export const returnOptions: SelectOption[] = [
  { label: 'applicant', value: DSRC_DECISION_TYPE.RETURN_TO_APPLICANT },
  { label: 'supervisor', value: DSRC_DECISION_TYPE.RETURN_TO_SUPERVISOR },
];

export const entranceRequirementOptions: SelectOption[] = [
  { label: 'Firm Offer', value: OFFER_TYPE.FIRM },
  {
    label: 'Conditional offer',
    value: OFFER_TYPE.CONDITION,
  },
];

export const conditionTypes = [
  {
    value: EntranceRequirement.CONDITIONAL_GENERAL,
    label: ADMISSION_FORM_TEXT.ADMISSION.GENERAL_REQUIREMENT,
  },
  {
    value: EntranceRequirement.CONDITIONAL_ENGLISH,
    label: ADMISSION_FORM_TEXT.ADMISSION.ENGLISH_REQUIREMENT,
  },
  {
    value: EntranceRequirement.CONDITION_OTHER_TEST,
    label: ADMISSION_FORM_TEXT.ADMISSION.OTHER_TEST_REQUIREMENT,
  },
  {
    value: EntranceRequirement.CONDITION_ADDITIONAL,
    label: ADMISSION_FORM_TEXT.ADMISSION.ADDITIONAL_REQUIREMENT,
  },
];

export const tuitionAssistantshipOptions: SelectOption[] = [
  { label: 'do not provide', value: TuitionAssistantship.NA },
  { label: 'provide 50%', value: TuitionAssistantship.HALF },
  { label: 'provide 100%', value: TuitionAssistantship.FULL },
];
